export function parseQuantityInput(raw) {
  return Number(String(raw ?? "").replace(",", ".").trim());
}

export function getProductUnitPrice(p) {
  if (!p) return 0;
  const rawPrice =
    p?.productPrice ??
    p?.product_price ??
    p?.price ??
    p?.sellPrice ??
    p?.sell_price ??
    0;
  const unitPrice =
    typeof rawPrice === "number" ? rawPrice : parseFloat(String(rawPrice).replace(",", "."));
  if (!Number.isFinite(unitPrice) || unitPrice < 0) return 0;
  return unitPrice;
}

export function lineTotalWithDiscountPercent(unitPrice, discountPercent, qty) {
  const d = Math.min(100, Math.max(0, Number(discountPercent) || 0));
  const factor = 1 - d / 100;
  return qty * unitPrice * factor;
}

export function normalizePromotionRewards(detail) {
  const rewards = Array.isArray(detail?.rewards) ? detail.rewards : [];
  const discountByProductId = {};
  const rows = [];

  rewards.forEach((r) => {
    const productId = r?.productId ?? r?.product_id;
    const dRaw = r?.discount;
    if (productId == null || dRaw === null || dRaw === undefined) return;
    const discount = Number(dRaw);
    if (!Number.isFinite(discount)) return;
    discountByProductId[String(productId)] = discount;
    rows.push({ productId, discount });
  });

  return { discountByProductId, rows };
}

export function countPositiveQtyLines(qtyInner) {
  if (!qtyInner || typeof qtyInner !== "object") return 0;
  return Object.values(qtyInner).filter((raw) => {
    const q = parseQuantityInput(raw);
    return Number.isFinite(q) && q > 0;
  }).length;
}

export function mergeProductCache(prev, list) {
  const byId = new Map((prev || []).map((p) => [String(p?._id ?? p?.id), p]));
  (list || []).forEach((p) => {
    const id = p?._id ?? p?.id;
    if (id == null) return;
    byId.set(String(id), { ...p, quantity: p?.quantity ?? 0 });
  });
  return [...byId.values()];
}
